"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasClass = exports.blurNode = exports.getPointerPosition = exports.findElPosition = void 0;
var react_dom_1 = require("react-dom");
/**
 * Offset Left
 * getBoundingClientRect technique from
 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @function findElPosition
 * @param el Element from which to get offset
 * @returns Top-left position of element
 */
function findElPosition(el) {
    var box;
    if (el.getBoundingClientRect && el.parentNode) {
        box = el.getBoundingClientRect();
    }
    if (!box) {
        return {
            left: 0,
            top: 0,
        };
    }
    var docEl = document.documentElement;
    var body = document.body;
    var clientLeft = docEl.clientLeft || body.clientLeft || 0;
    var scrollLeft = window.pageXOffset || body.scrollLeft;
    var left = box.left + scrollLeft - clientLeft;
    var clientTop = docEl.clientTop || body.clientTop || 0;
    var scrollTop = window.pageYOffset || body.scrollTop;
    var top = box.top + scrollTop - clientTop;
    // Android sometimes returns slightly off decimal values, so need to round
    return {
        left: Math.round(left),
        top: Math.round(top),
    };
}
exports.findElPosition = findElPosition;
/**
 * Get pointer position in element
 * Returns an object with x and y coordinates.
 * The base on the coordinates are the bottom left of the element.
 *
 * @function getPointerPosition
 * @param el Element on which to get the pointer position on
 * @param event Event object
 * @return This object will have x and y coordinates corresponding to the mouse position
 */
function getPointerPosition(el, event) {
    var box = findElPosition(el);
    var boxW = el.offsetWidth;
    var boxH = el.offsetHeight;
    var boxY = box.top;
    var boxX = box.left;
    var pageY = event.pageY;
    var pageX = event.pageX;
    if (event.changedTouches) {
        pageX = event.changedTouches[0].pageX;
        pageY = event.changedTouches[0].pageY;
    }
    return {
        x: Math.max(0, Math.min(1, (pageX - boxX) / boxW)),
        y: Math.max(0, Math.min(1, (boxY - pageY + boxH) / boxH)),
    };
}
exports.getPointerPosition = getPointerPosition;
/**
 * Blur an element
 * @param reactNode React node to blur
 * @deprecated Will be removed in a future major version
 */
function blurNode(reactNode) {
    // eslint-disable-next-line react/no-find-dom-node
    var domNode = (0, react_dom_1.findDOMNode)(reactNode);
    if (domNode === null || domNode === void 0 ? void 0 : domNode.blur) {
        domNode.blur();
    }
}
exports.blurNode = blurNode;
/**
 * Check if an element has a class name
 * @param elm React element
 * @param cls Class name
 * @returns Whether element has the given class name
 * @deprecated Will be removed in a future major version
 */
function hasClass(elm, cls) {
    var classes = elm.className.split(' ');
    for (var i = 0; i < classes.length; i++) {
        if (classes[i].toLowerCase() === cls.toLowerCase()) {
            return true;
        }
    }
    return false;
}
exports.hasClass = hasClass;
//# sourceMappingURL=dom.js.map